import React, { useEffect, useState } from "react";
import { primaryColor } from "../../../config/config";

type LangflowChatWidgetProps = {
    width?: number;
    height?: number;
};

const LangflowChatWidget: React.FC<LangflowChatWidgetProps> = ({
    width = 400,
    height = 500,
}) => {
    const flowId = process.env.REACT_APP_LANGFLOW_FLOW_ID;
    const hostUrl = process.env.REACT_APP_LANGFLOW_HOST_URL;
    const [scriptLoaded, setScriptLoaded] = useState(
        !!customElements.get("langflow-chat")
    );

    useEffect(() => {
        // Avoid re-loading the script if already defined or already loading
        if ((window as any).__langflow_script_loaded__ || customElements.get("langflow-chat")) {
            setScriptLoaded(true);
            return;
        }

        (window as any).__langflow_script_loaded__ = true;

        const script = document.createElement("script");
        script.src = "/langflow.bundle.min.js";
        script.async = true;
        script.crossOrigin = "anonymous";

        script.onload = () => {
            setScriptLoaded(true);
        };

        script.onerror = () => {
            console.error("Failed to load Langflow chat script.");
        };

        document.body.appendChild(script);
    }, []);

    if (!flowId || !hostUrl) {
        return null;
    }

    // Wait until custom element is defined
    if (!scriptLoaded && !customElements.get("langflow-chat")) return null;

    return (
        <langflow-chat
            flow_id={flowId}
            host_url={hostUrl}
            width={width}
            height={height}
            start_open={false}
            style={{ position: "fixed", bottom: "32px", right: "32px" }}
            window_title="[ui!] Workplace Agent"
            placeholder="Stelle eine Frage..."
            placeholder_sending="Sendet..."
            online_message="Online"
            offline_message="Offline"
            chat_position="top-left"
            className="langflow-chat-fixed"
            chat_window_style={JSON.stringify({
                borderRadius: "16px",
            })}
            send_button_style={JSON.stringify({
                color: "#fff",
                border: "none",
                padding: "8px 16px",
                borderRadius: "8px",
            })}
            send_icon_style={JSON.stringify({
                stroke: primaryColor,
                transition: "all 0.3s ease",
            })}
            user_message_style={JSON.stringify({
                backgroundColor: primaryColor,
                color: "#fff",
            })}
            bot_message_style={JSON.stringify({
                backgroundColor: `${primaryColor}22`,
                color: "#000",
            })}
            input_container_style={JSON.stringify({
            })}
            error_message_style={JSON.stringify({
                backgroundColor: "#f87171",
                color: "#fff",
            })}
            chat_trigger_style={JSON.stringify({
                backgroundColor: primaryColor,
                color: "#fff",
                borderRadius: "50%",
                width: "48px",
                height: "48px",
            })}
        ></langflow-chat>
    );
};

// Add this to prevent TypeScript error on <langflow-chat>
declare global {
    namespace JSX {
        interface IntrinsicElements {
            'langflow-chat': any;
        }
    }
}

export default LangflowChatWidget;
